module.exports = __webpack_public_path__ + "static/2-7198a31b691c06176822d13158f15a93.gif";